import React, { Suspense } from 'react';

import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import DarkModeToggle from "react-dark-mode-toggle";

import './assets/scss/menu.scss'
import './assets/scss/cloud.scss'
import './assets/css/background/stars.scss'
import './assets/css/background/spaceman.scss'
import './assets/css/background/birds.scss'

import { motion } from 'framer-motion/dist/framer-motion'

import { BrowserRouter as Router } from "react-router-dom";

import { useTranslation } from "react-i18next";
import LanguageFlags from './components/flags/LanguageFlags';
import {
  createTheme,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core/styles";
import App from './components/main/App';
import Button from '@material-ui/core/Button';
import Tooltip from '@mui/material/Tooltip';
import Projects from './components/projects/Projects';
import "react-tiger-transition/styles/main.min.css";
import { Navigation, Route, Screen, Link, fade, room } from "react-tiger-transition";
import arrowleftdark from './assets/img/arrow/arrow-left-dark.png'
import arrowrightdark from './assets/img/arrow/arrow-right-dark.png'

import astronaut from './assets/img/astronaut.png'
import './index.css'
import History from './components/history/History';
import Forms from './components/forms/Forms';
import { Fireworks, useFireworks } from "fireworks-js/dist/react";


// inject glide styles


room({
  name: 'cube-left',
  direction: 'left'
});
room({
  name: 'cube-right',
  direction: 'right'
});



// document.getElementById("root").style.backgroundColor = "#111";

export default function Main() {

  //Translation
  const { t } = useTranslation();

  // Hook for darkMode
  function useStickyState(defaultValue, key) {
    const [value, setValue] = React.useState(() => {
      const stickyValue = window.localStorage.getItem(key);
      return stickyValue !== null
        ? JSON.parse(stickyValue)
        : defaultValue;
    });
    React.useEffect(() => {
      window.localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);
    return [value, setValue];
  }

  const [darkMode, setDarkMode] = useStickyState(true, 'DarkMode?');
 
  const theme = createTheme({
    palette: {
      type: darkMode ? "dark" : "light",
      background: {
        default: darkMode ? '#263238' : '#81d4fa',
      },
    }
   
  })
  

  const useStyles = makeStyles((theme) => ({
  
toggler: {
  position: 'absolute',
  left: '0',
  paddingLeft: '15px',
  paddingTop: '28px',
  zIndex: '16',
  '@media (max-width:550px)': {
    transform: 'scale(0.8)'                             

  } 
},

arrowleft: {
  width:'60px',
  position:'fixed',
  Zindex:1000,
  left:'13px',
  top: '500px',
  "@media (max-width: 550px)": {
    width:'30px',
    top: '420px',
    left:'-5px',

  }
},
arrowright: {
  width:'60px',
  position:'fixed',
  Zindex:1000,
  right:'13px',
  top: '500px',
  "@media (max-width: 550px)": {
    width:'30px',
    top: '420px',
    right:'-5px',
  }
  },
// arrowleft2: {
//   width:'60px',
//   position:'fixed',
//   Zindex:1000,
//   left:'13px',
//   top: '500px',
  
//   "@media (max-width: 600px)": {
//     width:'30px',
//     top: '450px',
//   },
//   "@media (max-width: 500px)": {
//     width:'30px',
//     top: '220px',
//   },
// },
// arrowright2: {
//   width:'60px',
//   position:'fixed',
//   Zindex:1000,
//   right:'13px',
//   top: '500px',
//   "@media (max-width: 600px)": {
//     width:'30px',
//     top: '450px',
//   },
//   "@media (max-width: 500px)": {
//     width:'30px',
//     top: '220px',
//   },

// },
// arrowleft3: {
//   width:'60px',
//   position:'fixed',
//   Zindex:1000,
//   left:'13px',
//   top: '50%',
  
//   "@media (max-width: 1300px)": {
//     width:'30px',
//     top: '190px'
//   },
//   "@media (max-width: 600px)": {
//     width:'30px',
//     top: '190px',
//   },
//   "@media (max-width: 500px)": {
//     width:'30px',
//     top: '400px',
//   },
// },
// arrowright3: {
//   width:'60px',
//   position:'fixed',
//   Zindex:1000,
//   right:'13px',
//   top: '50%',
//   "@media (max-width: 1300px)": {
//     width:'30px',
//     top: '190px'
//   },
//   "@media (max-width: 600px)": {
//     width:'30px',
//     top: '190px',
//   },
//   "@media (max-width: 500px)": {
//     width:'30px',
//     top: '400px',
//   },
  
//   },
  navbardark: {
    height: '69px',
    backgroundColor: '#3d495e'
  },
  navbarlight: {
    height: '69px',
    backgroundColor: '#00b9e3'
  },
  fireworksbutton: {
    marginTop:'28px', 
    marginLeft:'170px',
    "@media (max-width: 550px)": {
          transform: 'scale(0.8)',
          marginLeft:'127px',
          marginTop:'30px',
        },
  },
  
 


  
}));


const classes = useStyles();



const { setEnabled, setOptions, enabled, options } = useFireworks({
  initialStart: false,
  initialOptions: {
    hue: {
      min: 0,
      max: 345
    },
    delay: {
      min: 15,
      max: 155
    },
    rocketsPoint: 15,
    speed: 9,
    acceleration: 1.2,
    friction: 0.96,
    gravity: 1,
    particles: 140,
    trace: 3,
    explosion: 6,
    autoresize: true,
    brightness: {
      min: 50,
      max: 80,
      decay: {
        min: 0.015,
        max: 0.03
      }
    },
    boundaries: {
      visible: false
    },
    sound: {
      enabled: true,
      files: [
        "https://fireworks.js.org/sounds/explosion0.mp3",
        "https://fireworks.js.org/sounds/explosion1.mp3",
        "https://fireworks.js.org/sounds/explosion2.mp3"
      ],
      volume: {
        min: 1,
        max: 2
      }
    },
    mouse: {
      click: true,
      move: false,
      max: 1
    }
  }
});


  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>

      <CssBaseline />   

                        <Container className={darkMode ? 'stars' : ''} maxWidth="sm">
                          {!darkMode 
                          ? 
                          <>
                          <motion.div
                initial={{ opacity: 0}}
                animate={{ opacity: 1}}
                transition={{
                    ease: "easeInOut",
                    duration: 1,
                }}
                >
                          <div id="Clouds">
                          <div className="demo-Cloud demo-Foreground"></div>
                          <div className="demo-Cloud demo-Background"></div>
                          <div className="demo-Cloud demo-Foreground"></div>
                          <div className="demo-Cloud demo-Background"></div>
                          <div className="demo-Cloud demo-Foreground"></div>
                          <div className="demo-Cloud demo-Background"></div>
                          <div className="demo-Cloud demo-Background"></div>
                          <div className="demo-Cloud demo-Foreground"></div>
                          <div className="demo-Cloud demo-Background"></div>
                          <div className="demo-Cloud demo-Background"></div> 

                          <div className="demo-Cloud demo-Background2"></div>                        
                          <div className="demo-Cloud demo-Background2"></div>                        
                          <div className="demo-Cloud demo-Background2"></div>                        
                          <div className="demo-Cloud demo-Background2"></div>                        
                          <div className="demo-Cloud demo-Background3"></div>                        
                          <div className="demo-Cloud demo-Background3"></div>                        
                          <div className="demo-Cloud demo-Background3"></div>                        
                          <div className="demo-Cloud demo-Background3"></div>                        
                          <div className="demo-Cloud demo-Background4"></div>                        
                          <div className="demo-Cloud demo-Background4"></div>                        
                          </div> 

                          <div className="bird-container bird-container--one">
	                        	<div className="bird bird--one"></div>
	                        </div>

	                        <div className="bird-container bird-container--two">
	                        	<div className="bird bird--two"></div>
	                        </div>

	                        <div className="bird-container bird-container--three">
	                        	<div className="bird bird--three"></div>
	                        </div>

	                        <div className="bird-container bird-container--four">
	                        	<div className="bird bird--four"></div>
	                        </div>    
                          </motion.div>                                                   
                          </>
                          : 
                          <>
                            <motion.div
                initial={{ opacity: 0}}
                animate={{ opacity: 1}}
                transition={{
                    ease: "easeInOut",
                    duration: 1,
                }}
                >
      
                          <div id='moon-container'>
                            <img  id="moon-img" src="https://upload.wikimedia.org/wikipedia/commons/c/c0/Moon_0063_Nevit.svg" height="150" align="middle"/>
		                    	<div id="cloud-container">
		                    		<img id="cloud-img" src="https://pbs.twimg.com/media/FILhPmRXMAUHOSX?format=png&name=4096x4096" height="450" align="middle"/>
		                    	</div>
		                    </div>
                        <div id="Clouds">
                        <div className="demo-Cloud demo-Background4"></div>
                        <div className="demo-Cloud demo-Background4"></div>
                        </div> 
                          
                          <div className="meteor-2"></div>
                          <div className="meteor-3"></div>
                         
                          <div className="spaceman-container">
                          <img className="spaceman" src={astronaut}/>
                          </div>
                    
                          </motion.div>

                        </>
                          }
                           
                      <AppBar className={darkMode ? classes.navbardark : classes.navbarlight}>
                      <motion.div
                initial={{ opacity: 0, y: -180 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                    ease: "easeInOut",
                    duration: 0.7,
                    
                }}
                >
                        <Grid container spacing={3} >
                        
                        <input id="page-nav-toggle" className="main-navigation-toggle" type="checkbox" />
                          <label htmlFor="page-nav-toggle">
                            <svg className="icon--menu-toggle" viewBox="0 0 60 30">
                              <g className="icon-group">
                                <g className={darkMode ? "icon--menuwhite" : "icon--menublack"}>
                                  <path d="M 6 0 L 54 0" />
                                  <path d="M 6 15 L 54 15" />
                                  <path d="M 6 30 L 54 30" />
                                </g>
                                <g className="icon--close">
                                  <path d="M 15 0 L 45 30" />
                                  <path d="M 15 30 L 45 0" />
                                </g>
                              </g>
                            </svg>
                          </label>
                                                  
                          <nav className="main-navigation">
                            <ul>
                              <li><a className="menu-words" href="/">{t('main')}🍯</a></li>
                              <li><a className="menu-words" href="/history">{t('history')}📜</a></li>
                              <li><a className="menu-words" href="/projects">{t('projects')}💡</a></li>
                              <li><a className="menu-words" href="/forms">{t('form')}📝</a></li>
                            </ul>
                          </nav>

                      <Button variant="outlined" className={classes.fireworksbutton} onClick={() => setEnabled()}>
                        {t('fireworks')} {enabled ? "🎉" : "💤"} 
                      </Button>

                        <LanguageFlags theme={theme}/>
                          <div className={classes.toggler}>
                            <Tooltip title={t('click_to_change')} arrow>
                            <DarkModeToggle
                            onChange={setDarkMode}
                            checked={darkMode}
                            size={70}
                          />
                            </Tooltip>
                            </div>   

                           
                      </Grid>   
                      </motion.div>                                               
                      </AppBar>
                    

          </Container> 
          <Fireworks enabled={enabled} options={options} style={{zIndex:'0', height:'100%', width:'70%', position:'fixed'}}></Fireworks>

        
         <Router>

    <Navigation>

      <Route exact path="/">
 
        <Screen className='scroll'>
                <App/>

          <Button disableRipple style={{ backgroundColor: 'transparent' }}>
          <Link to="/history" transition='cube-left'>
          <img src={arrowrightdark} className={classes.arrowright}/>
         </Link>
          </Button>

        </Screen>
      </Route>

      <Route
        exact path="/history"
        screen // shorthand to wrap children with screen
     >
       <History/>
       <Button disableRipple style={{ backgroundColor: 'transparent' }}>
        <Link to="/" transition='cube-right'>
        <img src={arrowleftdark} className={classes.arrowleft}/>
        </Link>
        <Link to="/projects" transition='cube-left'>
        <img src={arrowrightdark} className={classes.arrowright}/>
        </Link>
        </Button>
      </Route>

      <Route
        exact path="/projects"
        screen // shorthand to wrap children with screen
     >
       <Projects darkMode={darkMode}/>
       <Button disableRipple style={{ backgroundColor: 'transparent' }}>
        <Link to="/history" transition='cube-right'>
        <img src={arrowleftdark} className={classes.arrowleft}/>
        </Link>
        <Link to="/forms" transition='cube-left'>
        <img src={arrowrightdark} className={classes.arrowright}/>
        </Link>
        </Button>
      </Route>


      <Route
        exact path="/forms"
        screen // shorthand to wrap children with screen
     >
       <Forms darkMode={darkMode}/>
       <Button disableRipple style={{ backgroundColor: 'transparent' }}>
        <Link to="/projects" transition='cube-right'>
        <img src={arrowleftdark} className={classes.arrowleft}/>
        </Link>
        <Link to="/" transition='cube-left'>
        <img src={arrowrightdark} className={classes.arrowright}/>
        </Link>
        </Button>
      </Route>

    </Navigation>
  </Router>
       

      
 
     
       
      </ThemeProvider>
    </React.Fragment>   
  );
}